module.exports = __webpack_public_path__ + "static/img/11areaB_11.b372675.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/11areaB_11.png
// module id = 1091
// module chunks = 1